import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useEmitter } from 'hooks/useEmitter';
import { dataResources } from 'utils/constants';
import Image from 'next/image';
import Boto from 'components/3catinfo/Boto';
import Titol from 'components/3catinfo/Titol';
import Mosaic from 'components/3catinfo/Mosaic';
import Destacat from 'components/3catinfo/Destacat';
import TabSelector from 'components/3catinfo/Tabs/TabSelector';
import __isEmpty from 'lodash/isEmpty';
import styles from './entrevistes.module.scss';

const { basePath } = dataResources;
const imageLoader = ({ src }) => {
    return `${src}`;
};

const removeLastPathSegment = (path) => {
    const parts = path.split('/').filter(Boolean);
    parts.pop();
    return '/' + parts.join('/');
};

const Entrevistes = (props) => {
    const { titol, tag, tabsData, linkBanner, enllacExtern3Cat } = props;
    const router = useRouter();
    const { onEmitter } = useEmitter();
    const initIndexTab = Math.max(
        0,
        tabsData.findIndex((tab) => router.asPath.includes(tab.valor.url))
    );
    const [tabSelected, setTabSelected] = useState(tabsData[initIndexTab].valor);
    const [announcement, setAnnouncement] = useState('');
    const [toggleMessage, setToggleMessage] = useState(true);
    const route = removeLastPathSegment(router.asPath);

    useEffect(() => {
        window.history.replaceState({}, '', route + tabSelected.url + '/');
        setAnnouncement(toggleMessage ? "S'ha mostrat nou contingut" : "S'ha carregat nou contingut");
        setToggleMessage(!toggleMessage);
        setTimeout(() => {
            setAnnouncement('');
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabSelected]);

    onEmitter('eleccions-entrevistes', (value) => {
        setTabSelected(value);
    });

    return (
        <div className={styles.contentEntrevistes}>
            <div className={styles.capcalera}>
                <div className={styles.contentTitol}>
                    <Titol tag={tag || 'h2'} titol={titol} estil='ambParagraf' />
                </div>
                {tabsData.length > 1 && (
                    <TabSelector
                        tabId='eleccions-entrevistes'
                        items={tabsData}
                        tabInicial={initIndexTab}
                        estils='pb-0'
                        estilBotons='petit'
                    />
                )}
            </div>
            {props[tabSelected.items]?.item.length > 0 && (
                <div className={styles.llistatElectesWrapper}>
                    <Mosaic numColumns={3} numColumnsMobile={1} estilMosaic={'noGapAfter'} hGap={400} vGap={400}>
                        {props[tabSelected.items]?.item?.map((item) => {
                            return (
                                <Destacat
                                    key={`entrevistes-destacat-${item.id}`}
                                    {...item}
                                    routePath={tabSelected.path}
                                    enllacExtern3Cat={enllacExtern3Cat}
                                    className={styles.destacatEntrevistes}
                                    tipusImatge='web_destacat_entrevistes'
                                />
                            );
                        })}
                    </Mosaic>
                </div>
            )}
            {linkBanner && (
                <div className={styles.wrapperBanner}>
                    <div className={styles.contentBanner}>
                        <div className={styles.iconaBanner}>
                            <Image
                                loader={imageLoader}
                                unoptimized={true}
                                src={basePath + '/_resources/logos/3cat.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                width={105}
                                height={30}
                                loading='lazy'
                                alt='3Cat'
                            ></Image>
                        </div>
                        <span>Recupera les entrevistes de la plataform 3Cat</span>
                    </div>
                    <div className={styles.wrapperBotoBanner}>
                        <Boto
                            tag='a'
                            className={styles.botoBanner}
                            link={linkBanner}
                            text='Mira-ho ara'
                            dataTestId='testResultats-boto'
                            estil='ple100'
                            tema='secondary'
                            icona='ic_linkexterior'
                            iconaInline={true}
                            isIconaDreta={true}
                            isIconaBlanc={true}
                        />
                    </div>
                </div>
            )}
            <div aria-live='assertive' className={styles.announcement}>
                {announcement}
            </div>
        </div>
    );
};

export default Entrevistes;
